import { Link } from "react-router-dom";
import { Check, Wrench, Flame, Wind, ShieldCheck, Award, Clock, UserCheck, ArrowRight } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import CtaBand from "@/components/site/CtaBand";
import SEO from "@/components/site/SEO";
import { SERVICES } from "@/lib/siteData";

const ICONS = { plomberie: Wrench, chauffage: Flame, vmc: Wind };

export default function Services() {
  return (
    <div data-testid="services-page">
      <SEO
        title="Services Plomberie, Chauffage, VMC | Colmar, Mulhouse, Strasbourg — RM Plomberie"
        description="Installation chaudière, dépannage plomberie 7j/7, entretien VMC, pompe à chaleur, plancher chauffant, rénovation salle de bain à Colmar, Mulhouse, Strasbourg et tout le Haut-Rhin (68)."
        keywords="installation chaudière Colmar, dépannage fuite Mulhouse, entretien VMC Strasbourg, pompe à chaleur Alsace, plancher chauffant Colmar, ballon d'eau chaude Mulhouse, débouchage canalisation 68, rénovation salle de bain Alsace, plombier Colmar, plombier Mulhouse, plombier Strasbourg, chauffagiste 68, remplacement radiateur Haut-Rhin"
      />
      <PageHero
        breadcrumb="Nos services"
        kicker="Nos domaines d'expertise"
        title=" services"
        highlight="Nos"
        subtitle="RM Plomberie vous propose des solutions complètes en plomberie, chauffage et ventilation. Un travail soigné, des équipements de qualité et un service de proximité."
        useLogo
      />

      <section className="py-20 sm:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <p className="text-xs uppercase tracking-[0.28em] font-semibold text-[#005BBB] mb-3">Nos domaines d'expertise</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#001B35]">
              Des prestations complètes pour votre confort
            </h2>
            <div className="mt-5 w-16 h-1 bg-[#005BBB] mx-auto rounded-full" />
          </div>

          <div className="grid md:grid-cols-3 gap-7">
            {SERVICES.map((s) => {
              const Icon = ICONS[s.key];
              return (
                <article
                  key={s.key}
                  data-testid={`services-detail-${s.key}`}
                  className="rm-card bg-white rounded-2xl border border-gray-100 shadow-[0_4px_20px_-12px_rgba(0,27,53,0.15)] overflow-hidden flex flex-col"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
                    <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-14 h-14 rounded-full bg-[#005BBB] flex items-center justify-center shadow-lg ring-4 ring-white">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                  </div>
                  <div className="px-7 pt-10 pb-7 text-center flex-1 flex flex-col">
                    <h3 className="font-display text-xl font-bold text-[#001B35] uppercase tracking-wider">{s.title}</h3>
                    <p className="mt-3 text-sm text-gray-600 leading-relaxed">{s.subtitle}</p>
                    <ul className="mt-5 space-y-2.5 text-left flex-1">
                      {s.items.map((item) => (
                        <li key={item} className="flex items-start gap-2.5 text-sm text-gray-700">
                          <Check className="w-4 h-4 mt-0.5 text-[#005BBB] flex-shrink-0" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                    <Link
                      to="/contact"
                      data-testid={`services-cta-${s.key}`}
                      className="mt-6 inline-flex items-center justify-center gap-2 border-2 border-[#005BBB] text-[#005BBB] hover:bg-[#005BBB] hover:text-white rounded-full py-3 font-semibold uppercase text-sm tracking-wider transition"
                    >
                      Devis gratuit <ArrowRight className="w-4 h-4" />
                    </Link>
                  </div>
                </article>
              );
            })}
          </div>

          {/* Engagements */}
          <div className="mt-16 bg-[#F5F7FA] rounded-2xl p-8 sm:p-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { Icon: ShieldCheck, title: "Travail soigné", text: "Finitions propres et durables" },
              { Icon: Award, title: "Matériaux de qualité", text: "Équipements fiables sélectionnés" },
              { Icon: Clock, title: "Intervention rapide", text: "Réactivité et respect des délais" },
              { Icon: UserCheck, title: "Conseils personnalisés", text: "Solutions adaptées à vos besoins" },
            ].map(({ Icon, title, text }) => (
              <div key={title} className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                  <Icon className="w-6 h-6 text-[#005BBB]" />
                </div>
                <div>
                  <p className="font-display font-bold text-[#001B35]">{title}</p>
                  <p className="text-sm text-gray-600 mt-1">{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
